export const nounEndings = {
  'the one who is': '-lria',
  'device for': '+cuun',
  'one that often or capably is': '-tuli',
  'how to/way of': '@~+yaraq',
  'one who is good at': '@~-yuli',
  'act or state of': '-lleq ',
  'place for': '@~+vik'
};

export const absolutive_endings = {
  1: {
    0: {
      0: ''
    },
    1: {
      1: '-ka',
      2: '+(t)vuk',
      3: '+(t)vut'
    },
    2: {
      1: '%:(e)n',
      2: '-tek',
      3: '-ci'
    },
    3: {
      1: ':(6)a',
      2: ':(6)ak',
      3: ':(6)at'
    },
    4: {
      1: '-ni',
      2: '-tek',
      3: '-teng'
    }
  },
  3: {
    0: {
      0: '%:(e)t'
    },
    1: {
      1: '%:(e)nka',
      2: '-puk',
      3: '-put'
    },
    2: {
      1: '-ten',
      2: '-tek',
      3: '-ci'
    },
    3: {
      1: ':(6)i',
      2: '-kek',
      3: ':(6)it'
    },
    4: {
      1: '-ni',
      2: '-tek',
      3: '-teng'
    }
  },
  2: {
    0: {
      0: '%:(e)k'
    },
    1: {
      1: '%:(e)gka',
      2: '%:(e)gpuk',
      3: '%:(e)gput'
    },
    2: {
      1: '%:(e)gken',
      2: '%:(e)gtek',
      3: '%:(e)gci'
    },
    3: {
      1: '%:(e)k',
      2: '%:(e)gkek',
      3: '%:(e)gket'
    },
    4: {
      1: '%:(e)gni',
      2: '%:(e)gtek',
      3: '%:(e)gteng'
    }
  }
};

export const relative_endings = {
  1: {
    0: {
      0: '%:(e)m'
    },
    1: {
      1: '-ma',
      2: '-megnuk',
      3: '-mta'
    },
    2: {
      1: '+(t)vet',
      2: '+(t)vetek',
      3: '+(t)veci'
    },
    3: {
      1: ':(6)an',
      2: ':(6)agnek',
      3: ':(6)ata'
    },
    4: {
      1: '-mi',
      2: '-mek',
      3: '-meng'
    }
  },
  2: {
    0: {
      0: '%:(e)k'
    },
    1: {
      1: '%:(e)gma',
      2: '%:(e)gmegnuk',
      3: '%:(e)gemta'
    },
    2: {
      1: '%:(e)gpet',
      2: '%:(e)gpetek',
      3: '%:(e)gpeci'
    },
    3: {
      1: '%:(e)gken',
      2: '%:(e)gkenka',
      3: '%:(e)gketa'
    },
    4: {
      1: '%:(e)gmi',
      2: '%:(e)gmek',
      3: '%:(e)gmeng'
    }
  },
  3: {
    0: {
      0: '%:(e)t'
    },
    1: {
      1: '-ma',
      2: '-megnuk',
      3: '-mta'
    },
    2: {
      1: '+(t)vet',
      2: '+(t)vetek',
      3: '+(t)veci'
    },
    3: {
      1: ':(6)in',
      2: '-kenka',
      3: ':(6)ita'
    },
    4: {
      1: '-mi',
      2: '-mek',
      3: '-meng'
    }
  }
};



export const localis_endings = {
  1: {
    0: {
      0: '%~mi'
    },
    1: {
      1: '-mni',
      2: '-megni',
      3: '-mte7i'
    },
    2: {
      1: '+(t)veni',
      2: '+(t)vetegni',
      3: '+(t)vece7i'
    },
    3: {
      1: ':(6)ani',
      2: ':(6)agni',
      3: ':(6)atni'
    },
    4: {
      1: '-mini',
      2: '-megni',
      3: '-meggni'
    }
  },
  2: {
    0: {
      0: '%:(e)gni'
    },
    1: {
      1: '%:(e)gemni',
      2: '%:(e)gmegni',
      3: '%:(e)gemte7i'
    },
    2: {
      1: '%:(e)gpeni',
      2: '%:(e)gpetegni',
      3: '%:(e)gpece7i'
    },
    3: {
      1: '%:(e)gkeni',
      2: '%:(e)gkegni',
      3: '%:(e)gketni'
    },
    4: {
      1: '%:(e)gmini',
      2: '%:(e)gmegni',
      3: '%:(e)gmeggni'
    }
  },
  3: {
    0: {
      0: '%~ni'
    },
    1: {
      1: '-mni',
      2: '-megni',
      3: '-mte7i'
    },
    2: {
      1: '+(t)veni',
      2: '+(t)vetegni',
      3: '+(t)vece7i'
    },
    3: {
      1: ':(6)ini',
      2: '-kegni',
      3: ':(6)itni'
    },
    4: {
      1: '-mini',
      2: '-megni',
      3: '-meggni'
    }
  }
};

export const ablative_endings = {
  1: {
    0: {
      0: '%~mek'
    },
    1: {
      1: '-mnek',
      2: '-megnek',
      3: '-mte7ek'
    },
    2: {
      1: '+(t)venek',
      2: '+(t)vetegnek',
      3: '+(t)vece7ek'
    },
    3: {
      1: ':(6)anek',
      2: ':(6)agnek',
      3: ':(6)atnek'
    },
    4: {
      1: '-minek',
      2: '-megnek',
      3: '-meggnek'
    }
  },
  2: {
    0: {
      0: '%:(e)gnek'
    },
    1: {
      1: '%:(e)gemnek',
      2: '%:(e)gmegnek',
      3: '%:(e)gemte7ek'
    },
    2: {
      1: '%:(e)gpenek',
      2: '%:(e)gpetegnek',
      3: '%:(e)gpece7ek'
    },
    3: {
      1: '%:(e)gkenek',
      2: '%:(e)gkegnek',
      3: '%:(e)gketnek'
    },
    4: {
      1: '%:(e)gminek',
      2: '%:(e)gmegnek',
      3: '%:(e)gmeggnek'
    }
  },
  3: {
    0: {
      0: '%~nek'
    },
    1: {
      1: '-mnek',
      2: '-megnek',
      3: '-mte7ek'
    },
    2: {
      1: '+(t)venek',
      2: '+(t)vetegnek',
      3: '+(t)vece7ek'
    },
    3: {
      1: ':(6)inek',
      2: '-kegnek',
      3: ':(6)itnek'
    },
    4: {
      1: '-minek',
      2: '-megnek',
      3: '-meggnek'
    }
  }
};

export const terminalis_endings = {
  1: {
    0: {
      0: '%~mun'
    },
    1: {
      1: '-mnun',
      2: '-megnun',
      3: '-mte7un'
    },
    2: {
      1: '+(t)venun',
      2: '+(t)vetegnun',
      3: '+(t)vece7un'
    },
    3: {
      1: ':(6)anun',
      2: ':(6)agnun',
      3: ':(6)atnun'
    },
    4: {
      1: '-minun',
      2: '-megnun',
      3: '-meggnun'
    }
  },
  2: {
    0: {
      0: '%:(e)gnun'
    },
    1: {
      1: '%:(e)gemnun',
      2: '%:(e)gmegnun',
      3: '%:(e)gemte7un'
    },
    2: {
      1: '%:(e)gpenun',
      2: '%:(e)gpetegnun',
      3: '%:(e)gpece7un'
    },
    3: {
      1: '%:(e)gkenun',
      2: '%:(e)gkegnun',
      3: '%:(e)gketnun'
    },
    4: {
      1: '%:(e)gminun',
      2: '%:(e)gmegnun',
      3: '%:(e)gmeggnun'
    }
  },
  3: {
    0: {
      0: '%~nun'
    },
    1: {
      1: '-mnun',
      2: '-megnun',
      3: '-mte7un'
    },
    2: {
      1: '+(t)venun',
      2: '+(t)vetegnun',
      3: '+(t)vece7un'
    },
    3: {
      1: ':(6)inun',
      2: '-kegnun',
      3: ':(6)itnun'
    },
    4: {
      1: '-minun',
      2: '-megnun',
      3: '-meggnun'
    }
  }
};

export const vialis_endings = {
  1: {
    0: {
      0: '%kun'
    },
    1: {
      1: '-mkun',
      2: '-megnegun',
      3: '-mteggun'
    },
    2: {
      1: '+(t)vegun', //also include -vkun
      2: '+(t)vetegnegun', //-vcetgun
      3: '+(t)vecetgun' //-vtegnegun
    },
    3: {
      1: ':(6)akun',
      2: ':(6)agnegun',
      3: ':(6)atgun'
    },
    4: {
      1: '-mikun',
      2: '-megnegun',
      3: '-megteggun'
    }
  },
  2: {
    0: {
      0: '%:(e)gnegun'
    },
    1: {
      1: '%:(e)gemkun',
      2: '%:(e)gmegnegun',
      3: '%:(e)gemteggun'
    },
    2: {
      1: '%:(e)gpegun',
      2: '%:(e)gpetegnegun',
      3: '%:(e)gpecetnun'
    },
    3: {
      1: '%:(e)gkenkun',
      2: '%:(e)gketgun',
      3: '%:(e)gkegnegun'
    },
    4: {
      1: '%:(e)gmikun',
      2: '%:(e)gmegnegun',
      3: '%:(e)gmegteggun'
    }
  },
  3: {
    0: {
      0: '%tgun'
    },
    1: {
      1: '-mkun',
      2: '-megnegun',
      3: '-mteggun'
    },
    2: {
      1: '+(t)vegun',
      2: '+(t)vetegnegun',
      3: '+(t)vecetgun'
    },
    3: {
      1: ':(6)ikun',
      2: '-kegnegun',
      3: ':(6)itgun'
    },
    4: {
      1: '-mikun',
      2: '-megnegun',
      3: '-megteggun'
    }
  }
};

export const equalis_endings = {
  1: {
    0: {
      0: '%tun'
    },
    1: {
      1: '-mtun',
      2: '-megtun',
      3: '-mcetun'
    },
    2: {
      1: '+(t)vetun', //also include -vkun
      2: '+(t)vetegtun', //-vcetgun
      3: '+(t)vecetun' //-vtegnegun
    },
    3: {
      1: ':(6)atun',
      2: ':(6)agtun',
      3: ':(6)acetun'
    },
    4: {
      1: '-mitun',
      2: '-megtun',
      3: '-megcetun'
    }
  },
  2: {
    0: {
      0: '%:(e)gtun'
    },
    1: {
      1: '%:(e)gemtun',
      2: '%:(e)gmegtun',
      3: '%:(e)gemcetun'
    },
    2: {
      1: '%:(e)gpetun',
      2: '%:(e)gpetegtun',
      3: '%:(e)gpecetun'
    },
    3: {
      1: '%:(e)gketun',
      2: '%:(e)gkegtun',
      3: '%:(e)gkecetun'
    },
    4: {
      1: '%:(e)gmitun',
      2: '%:(e)gmegtun',
      3: '%:(e)gmegcetun'
    }
  },
  3: {
    0: {
      0: '%tun'
    },
    1: {
      1: '-mtun',
      2: '-megtun',
      3: '-mcetun'
    },
    2: {
      1: '+(t)vetun', //also include -vkun
      2: '+(t)vetegtun', //-vcetgun
      3: '+(t)vecetun' //-vtegnegun
    },
    3: {
      1: ':(6)itun',
      2: '-kegtun',
      3: ':(6)icetun'
    },
    4: {
      1: '-mitun',
      2: '-megtun',
      3: '-megcetun'
    }
  }
};

export const indicative_intransitive_endings = {
  1: { // 1st person
    1: '+\'(g/t)u:6a', // I
    2: '+\'(g/t)ukuk', // you
    3: '+\'(g/t)ukut', // he
  },
  2: {
    1: '+\'(g/t)uten', // I
    2: '+\'(g/t)utek', // you
    3: '+\'(g/t)uci', // he
  },
  3: {
    1: '+\'(g/t)uq',
    2: '+\'(g/t)uk',
    3: '+\'(g/t)ut',
  }
};

export const indicative_transitive_endings = {
  1: {
    1: {
      1: {
        1:'', //not allowed
        2:'',
        3:'',
      },
      2: {
        1:'+\'(g)amken',
        2:'+\'(g)amtek',
        3:'+\'(g)amci',
      },
      3: {
        1:'+\'(g)aqa',
        2:'+\'(g)agka',
        3:'+\'(g)anka',
      },
    },
    2: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'+\'(g)amegten',
        2:'+\'(g)amegtek',
        3:'+\'(g)amegci',
      },
      3: {
        1:'+\'(g)apuk',
        2:'+\'(g)agpuk',
        3:'+\'(g)apuk',
      },
    },
    3: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'+\'(g)amte4en',
        2:'+\'(g)amcetek',
        3:'+\'(g)amceci',
      },
      3: {
        1:'+\'(g)aput',
        2:'+\'(g)agput',
        3:'+\'(g)aput',
      }
    }
  },
  2: {
    1: {
      1: {
        1:'+\'(g)arpenga',
        2:'+\'(g)arpekuk',
        3:'+\'(g)arpekut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'+\'(g)an',
        2:'+\'(g)agken',
        3:'+\'(g)aten',
      },
    },
    2: {
      1: {
        1:'+\'(g)arpetegnga',
        2:'+\'(g)arpetegkuk',
        3:'+\'(g)arpetegkut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'+\'(g)atek',
        2:'+\'(g)agtek',
        3:'+\'(g)atek',
      },
    },
    3: {
      1: {
        1:'+\'(g)arpecia',
        2:'+\'(g)arpecikuk',
        3:'+\'(g)arpecikut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'+\'(g)aci',
        2:'+\'(g)agci',
        3:'+\'(g)aci',
      }
    }
  },
  3: {
    1: {
      1: {
        1:'+\'(g)anga',
        2:'+\'(g)akuk',
        3:'+\'(g)akut',
      },
      2: {
        1:'+\'(g)aten',
        2:'+\'(g)atek',
        3:'+\'(g)aci',
      },
      3: {
        1:'+\'(g)aa',
        2:'+\'(g)ak',
        3:'+\'(g)ai',
      },
    },
    2: {
      1: {
        1:'+\'(g)agnga',
        2:'+\'(g)agkuk',
        3:'+\'(g)agkut',
      },
      2: {
        1:'+\'(g)agten',
        2:'+\'(g)agtek',
        3:'+\'(g)agci',
      },
      3: {
        1:'+\'(g)aak',
        2:'+\'(g)agkek',
        3:'+\'(g)akek',
      },
    },
    3: {
      1: {
        1:'+\'(g)atnga',
        2:'+\'(g)aitkuk',
        3:'+\'(g)aitkut',
      },
      2: {
        1:'+\'(g)atgen',
        2:'+\'(g)aicetek',
        3:'+\'(g)aiceci',
      },
      3: {
        1:'+\'(g)aat',
        2:'+\'(g)agket',
        3:'+\'(g)ait',
      }
    }
  }
};

export const interrogative_intransitive_endings = {
  1: { // 1st person
    1: '~+(t)sia',
    2: '@~+ce7uk',
    3: '@~+ceta',
  },
  2: {
    1: '~+(t)sit',
    2: '@~+cetek',
    3: '@~+ceci',
  },
  3: {
    1: '+\'(g/t)a',
    2: '+\'(g/t)ak',
    3: '+\'(g/t)at',
  }
};

export const interrogative_transitive_endings = {
  1: {
    1: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'',
        2:'',
        3:'',
      },
    },
    2: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'',
        2:'',
        3:'',
      },
    },
    3: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'',
        2:'',
        3:'',
      }
    }
  },
  2: {
    1: {
      1: {
        1:'~+(t)sia',
        2:'~+(t)sikuk',
        3:'~+(t)sikut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'~+(t)siu',
        2:'~+(t)sikek',
        3:'~+(t)siki',
      },
    },
    2: {
      1: {
        1:'@~+cetegnga',
        2:'@~+cetegkuk',
        3:'@~+cetegkut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'@~+cetegnegu',
        2:'@~+cetegkek',
        3:'@~+cetegki',
      },
    },
    3: {
      1: {
        1:'@~+cecia',
        2:'@~+cecikuk',
        3:'@~+cecikut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'@~+ceciu',
        2:'@~+cecikek',
        3:'@~+ceciki',
      }
    }
  },
  3: {
    1: {
      1: {
        1:'+\'(g/t)anga',
        2:'+\'(g/t)akuk',
        3:'+\'(g/t)akut',
      },
      2: {
        1:'+\'(g/t)aten',
        2:'+\'(g/t)atek',
        3:'+\'(g/t)aci',
      },
      3: {
        1:'+\'(g/t)a:gu',
        2:'+\'(g/t)akek',
        3:'+\'(g/t)aki',
      },
    },
    2: {
      1: {
        1:'+\'(g/t)agnga',
        2:'+\'(g/t)agkuk',
        3:'+\'(g/t)agkut',
      },
      2: {
        1:'+\'(g/t)agten',
        2:'+\'(g/t)agtek',
        3:'+\'(g/t)agci',
      },
      3: {
        1:'+\'(g/t)agnegu',
        2:'+\'(g/t)agkek',
        3:'+\'(g/t)agki',
      },
    },
    3: {
      1: {
        1:'+\'(g/t)atnga',
        2:'+\'(g/t)atkuk',
        3:'+\'(g/t)atkut',
      },
      2: {
        1:'+\'(g/t)atgen',
        2:'+\'(g/t)acetek',
        3:'+\'(g/t)aceci',
      },
      3: {
        1:'+\'(g/t)atgu',
        2:'+\'(g/t)atkek',
        3:'+\'(g/t)atki',
      }
    }
  }
};

export const optative_intransitive_endings = {
  1: { // 1st person
    1: '@~+lii', //if te ending, tl becomes ll
    2: '@~+luk', //if te ending, tl becomes ll
    3: '-lta', // also %(e)lta
  },
  2: {
    1: '$', // ending in a, i, u, do nothing. ending in two vowels or e, (g)i. ending in te, ending is n. consonant ending, end is :a. special te, ending is lu.
    2: '@+tek',//drops te from bases
    3: '@+ci',
  },
  3: {
    1: '@~+li', //if te ending, tl becomes ll
    2: '@~+lik', //if te ending, tl becomes ll
    3: '@~+lit', //if te ending, tl becomes ll
  }
};

export const optative_transitive_endings = {
  1: {
    1: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'@~+lamken',
        2:'@~+lamtek',
        3:'@~+lamci',
      },
      3: {
        1:'@~+laku',
        2:'@~+lakek',
        3:'@~+laki',
      },
    },
    2: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'@~+lamegten',
        2:'@~+lamegtek',
        3:'@~+lamegci',
      },
      3: {
        1:'@+lauk',
        2:'@+lagpuk',
        3:'@+lapuk',
      },
    },
    3: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'@~+lamte4en',
        2:'@~+lamcetek',
        3:'@~+lamceci',
      },
      3: {
        1:'@+laut',
        2:'@+lagput',
        3:'@+laput',
      }
    }
  },
  2: {
    1: {
      1: {
        1:'@+6a',
        2:'@+kuk',
        3:'@+kut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'&',
        2:'@+kek',
        3:'@+ki',
      },
    },
    2: {
      1: {
        1:'@+tegnga',
        2:'@+tegkuk',
        3:'@+tegkut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'@+tegu',
        2:'@+tegkek',
        3:'@+tegki',
      },
    },
    3: {
      1: {
        1:'@+cia',
        2:'@+cikuk',
        3:'@+cikut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'@+ciu',
        2:'@+ciki',
        3:'@+cikek',
      }
    }
  },
  3: {
    1: {
      1: {
        1:'@~+lia',
        2:'@~+likuk',
        3:'@~+likut',
      },
      2: {
        1:'@~+liten',
        2:'@~+litek',
        3:'@~+lici',
      },
      3: {
        1:'@~+liu',
        2:'@~+likek',
        3:'@~+liki',
      },
    },
    2: {
      1: {
        1:'@~+lignga',
        2:'@~+ligkuk',
        3:'@~+ligkut',
      },
      2: {
        1:'@~+ligten',
        2:'@~+ligtek',
        3:'@~+ligci',
      },
      3: {
        1:'@~+lignegu',
        2:'@~+ligkek',
        3:'@~+ligki',
      },
    },
    3: {
      1: {
        1:'@~+litnga',
        2:'@~+litkuk',
        3:'@~+litkut',
      },
      2: {
        1:'@~+litgen',
        2:'@~+licetek',
        3:'@~+liceci',
      },
      3: {
        1:'@~+litgu',
        2:'@~+litkek',
        3:'@~+litki',
      }
    }
  }
};

export const subordinative_intransitive_endings = {
  1: {
    1: '@~+lua',
    2: '@~+lunuk',
    3: '@~+luta',
  },
  2: {
    1: '@~+luten',
    2: '@~+lutek',
    3: '@~+luci',
  },
  4: {
    1: '@~+luni',
    2: '@~+lutek',
    3: '@~+luteng',
  }
};

export const subordinative_transitive_endings = {
  1: {
    1: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'@~+luten',
        2:'@~+lutek',
        3:'@~+luci',
      },
      3: {
        1:'@~+luku',
        2:'@~+lukek',
        3:'@~+luki',
      },
    },
    2: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'@~+luten',
        2:'@~+lutek',
        3:'@~+luci',
      },
      3: {
        1:'@~+luku',
        2:'@~+lukek',
        3:'@~+luki',
      },
    },
    3: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'@~+luten',
        2:'@~+lutek',
        3:'@~+luci',
      },
      3: {
        1:'@~+luku',
        2:'@~+lukek',
        3:'@~+luki',
      }
    }
  },
  2: {
    1: {
      1: {
        1:'@~+lua',
        2:'@~+lunuk',
        3:'@~+luta',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'@~+luku',
        2:'@~+lukek',
        3:'@~+luki',
      },
    },
    2: {
      1: {
        1:'@~+lua',
        2:'@~+lunuk',
        3:'@~+luta',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'@~+luku',
        2:'@~+lukek',
        3:'@~+luki',
      },
    },
    3: {
      1: {
        1:'@~+lua',
        2:'@~+lunuk',
        3:'@~+luta',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'@~+luku',
        2:'@~+lukek',
        3:'@~+luki',
      }
    }
  },
  4: {
    1: {
      1: {
        1:'@~+lua',
        2:'@~+lunuk',
        3:'@~+luta',
      },
      2: {
        1:'@~+luten',
        2:'@~+lutek',
        3:'@~+luci',
      },
      3: {
        1:'@~+luku',
        2:'@~+lukek',
        3:'@~+luki',
      },
    },
    2: {
      1: {
        1:'@~+lua',
        2:'@~+lunuk',
        3:'@~+luta',
      },
      2: {
        1:'@~+luten',
        2:'@~+lutek',
        3:'@~+luci',
      },
      3: {
        1:'@~+luku',
        2:'@~+lukek',
        3:'@~+luki',
      },
    },
    3: {
      1: {
        1:'@~+lua',
        2:'@~+lunuk',
        3:'@~+luta',
      },
      2: {
        1:'@~+luten',
        2:'@~+lutek',
        3:'@~+luci',
      },//
      3: {
        1:'@~+luku',
        2:'@~+lukek',
        3:'@~+luki',
      }
    }
  }
};

export const connective_intransitive_endings = {
  1: {
    1: '+ma',
    2: '-megnuk',
    3: '-mta',
  },
  2: {
    1: '+(t)vet',
    2: '+(t)vtek',
    3: '+(t)vci',
  },
  3: {
    1: ':an',
    2: ':agnek',
    3: ':ata',
  },
  4: {
    1: '+mi',
    2: '+mek',
    3: '+meng',
  }
};

export const connective_transitive_endings = {
  1: {
    1: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'-mken',
        2:'-mtek',
        3:'-mci',
      },
      3: {
        1:'-mku',
        2:'-mkek',
        3:'-mki',
      },
      4: {
        1:'-mni',
        2:'-mtek',
        3:'-mteng',
      },
    },
    2: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'-megten',
        2:'-megtek',
        3:'-megci',
      },
      3: {
        1:'-megnegu',
        2:'-megkek',
        3:'-megki',
      },
      4: {
        1:'-megni',
        2:'-megtek',
        3:'-megteng',
      },
    },
    3: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'-mte4en',
        2:'-mcetek',
        3:'-mceci',
      },
      3: {
        1:'-mte4u',
        2:'-mtekek',
        3:'-mteki',
      },
      4: {
        1:'-mteni',
        2:'-mcetek',
        3:'-mceteng',
      },
    }
  },
  2: {
    1: {
      1: {
        1:'+(t)vnga',
        2:'+(t)vkuk',
        3:'+(t)vkut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'+(t)vgu',
        2:'+(t)vkek',
        3:'+(t)vki',
      },
      4: {
        1:'+(t)vni',
        2:'+(t)vtek',
        3:'+(t)vteng',
      },
    },
    2: {
      1: {
        1:'+(t)vtegnga',
        2:'+(t)vtegkuk',
        3:'+(t)vtegkut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'+(t)vtegni',
        2:'+(t)vtegtek',
        3:'+(t)vtegteng',
      },
      4: {
        1:'+(t)vtegu',
        2:'+(t)vtegkek',
        3:'+(t)vtegki',
      },
    },
    3: {
      1: {
        1:'+(t)vcia',
        2:'+(t)vcikuk',
        3:'+(t)vcikut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'+(t)vciu',
        2:'+(t)vcikek',
        3:'+(t)vciki',
      },
      4: {
        1:'+(t)vce7i',
        2:'+(t)vcetek',
        3:'+(t)vceteng',
      }
    }
  },
  3: {
    1: {
      1: {
        1:':anga',
        2:':akuk',
        3:':akut',
      },
      2: {
        1:':aten',
        2:':atek',
        3:':aci',
      },
      3: {
        1:':aku',
        2:':akek',
        3:':aki',
      },
      4: {
        1:':ani',
        2:':atek',
        3:':ateng',
      },
    },
    2: {
      1: {
        1:':agnga',
        2:':agkuk',
        3:':agkut',
      },
      2: {
        1:':agten',
        2:':agtek',
        3:':agci',
      },
      3: {
        1:':agku',
        2:':agkek',
        3:':agki',
      },
      4: {
        1:':agni',
        2:':agtek',
        3:':agteng',
      },
    },
    3: {
      1: {
        1:':atnga',
        2:':atkuk',
        3:':atkut',
      },
      2: {
        1:':atgen',
        2:':acetek',
        3:':aceci',
      },
      3: {
        1:':atgu',
        2:':atkek',
        3:':atki',
      },
      4: {
        1:':atni',
        2:':acetek',
        3:':aceteng',
      },
    }
  },
  4: {
    1: {
      1: {
        1:'+mia',
        2:'+mikuk',
        3:'+mikut',
      },
      2: {
        1:'+miten',
        2:'+mitek',
        3:'+mici',
      },
      3: {
        1:'+miu',
        2:'+mikek',
        3:'+miki',
      },
      4: {
        1:'',
        2:'',
        3:'',
      },
    },
    2: {
      1: {
        1:'+megnenga',
        2:'+megnekuk',
        3:'+megnekut',
      },
      2: {
        1:'+megnegen',
        2:'+megnetek',
        3:'+megneci',
      },
      3: {
        1:'+megnegu',
        2:'+megnekek',
        3:'+megneki',
      },
      4: {
        1:'',
        2:'',
        3:'',
      },
    },
    3: {
      1: {
        1:'+megtenga',
        2:'+megtekuk',
        3:'+megtekut',
      },
      2: {
        1:'+megte4en',
        2:'+megcetek',
        3:'+megneci',
      },
      3: {
        1:'+megte4u',
        2:'+megtekek',
        3:'+megteki',
      },
      4: {
        1:'',
        2:'',
        3:'',
      }
    }
  }
};

export const connective_consonantEnd_intransitive_endings = {
  1: {
    1: '+ma',
    2: '-megnuk',
    3: '-mta',
  },
  2: {
    1: '+(t)vet',
    2: '+(t)vetek',
    3: '+(t)veci',
  },
  3: {
    1: ':an',
    2: ':agnek',
    3: ':ata',
  },
  4: {
    1: '+mi',
    2: '+mek',
    3: '+meng',
  }
};

export const connective_consonantEnd_transitive_endings = {
  1: {
    1: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'-mken',
        2:'-mtek',
        3:'-mci',
      },
      3: {
        1:'-mku',
        2:'-mkek',
        3:'-mki',
      },
      4: {
        1:'-mni',
        2:'-mtek',
        3:'-mteng',
      },
    },
    2: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'-megten',
        2:'-megtek',
        3:'-megci',
      },
      3: {
        1:'-megnegu',
        2:'-megkek',
        3:'-megki',
      },
      4: {
        1:'-megni',
        2:'-megtek',
        3:'-megteng',
      },
    },
    3: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'-mte4en',
        2:'-mcetek',
        3:'-mceci',
      },
      3: {
        1:'-mte4u',
        2:'-mtekek',
        3:'-mteki',
      },
      4: {
        1:'-mteni',
        2:'-mcetek',
        3:'-mceteng',
      },
    }
  },
  2: {
    1: {
      1: {
        1:'+(t)venga',
        2:'+(t)vekuk',
        3:'+(t)vekut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'+(t)vegu',
        2:'+(t)vekek',
        3:'+(t)veki',
      },
      4: {
        1:'+(t)veni',
        2:'+(t)vetek',
        3:'+(t)veteng',
      },
    },
    2: {
      1: {
        1:'+(t)vetegnga',
        2:'+(t)vetegkuk',
        3:'+(t)vetegkut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'+(t)vetegni',
        2:'+(t)vetegtek',
        3:'+(t)vetegteng',
      },
      4: {
        1:'+(t)vetgu',
        2:'+(t)vetegkek',
        3:'+(t)vetegki',
      },
    },
    3: {
      1: {
        1:'+(t)vecia',
        2:'+(t)vecikuk',
        3:'+(t)vecikut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'+(t)veciu',
        2:'+(t)vecikek',
        3:'+(t)veciki',
      },
      4: {
        1:'+(t)vece7i',
        2:'+(t)vecetek',
        3:'+(t)veceteng',
      }
    }
  },
  3: {
    1: {
      1: {
        1:':anga',
        2:':akuk',
        3:':akut',
      },
      2: {
        1:':aten',
        2:':atek',
        3:':aci',
      },
      3: {
        1:':aku',
        2:':akek',
        3:':aki',
      },
      4: {
        1:':ani',
        2:':atek',
        3:':ateng',
      },
    },
    2: {
      1: {
        1:':agnga',
        2:':agkuk',
        3:':agkut',
      },
      2: {
        1:':agten',
        2:':agtek',
        3:':agci',
      },
      3: {
        1:':agku',
        2:':agkek',
        3:':agki',
      },
      4: {
        1:':agni',
        2:':agtek',
        3:':agteng',
      },
    },
    3: {
      1: {
        1:':atnga',
        2:':atkuk',
        3:':atkut',
      },
      2: {
        1:':atgen',
        2:':acetek',
        3:':aceci',
      },
      3: {
        1:':atgu',
        2:':atkek',
        3:':atki',
      },
      4: {
        1:':atni',
        2:':acetek',
        3:':aceteng',
      },
    }
  },
  4: {
    1: {
      1: {
        1:'+mia',
        2:'+mikuk',
        3:'+mikut',
      },
      2: {
        1:'+miten',
        2:'+mitek',
        3:'+mici',
      },
      3: {
        1:'+miu',
        2:'+mikek',
        3:'+miki',
      },
      4: {
        1:'',
        2:'',
        3:'',
      },
    },
    2: {
      1: {
        1:'+megnenga',
        2:'+megnekuk',
        3:'+megnekut',
      },
      2: {
        1:'+megnegen',
        2:'+megnetek',
        3:'+megneci',
      },
      3: {
        1:'+megnegu',
        2:'+megnekek',
        3:'+megneki',
      },
      4: {
        1:'',
        2:'',
        3:'',
      },
    },
    3: {
      1: {
        1:'+megtenga',
        2:'+megtekuk',
        3:'+megtekut',
      },
      2: {
        1:'+megte4en',
        2:'+megcetek',
        3:'+megneci',
      },
      3: {
        1:'+megte4u',
        2:'+megtekek',
        3:'+megteki',
      },
      4: {
        1:'',
        2:'',
        3:'',
      }
    }
  }
};

export const connective_contemporative_intransitive_endings = {
  1: {
    1: '-mni',
    2: '-megni',
    3: '-mte7i',
  },
  2: {
    1: '+(t)veni',
    2: '+(t)vetegni',
    3: '+(t)vece7i',
  },
  3: {
    1: ':ani',
    2: ':agni',
    3: ':atni',
  },
  4: {
    1: '+mini',
    2: '+megni',
    3: '+me4ni',
  }
};

export const connective_contemporative_transitive_endings = {
  1: {
    1: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'-mken',
        2:'-mtek',
        3:'-mci',
      },
      3: {
        1:'-mku',
        2:'-mkek',
        3:'-mki',
      },
      4: {
        1:'-mni',
        2:'-mtek',
        3:'-mteng',
      },
    },
    2: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'-megten',
        2:'-megtek',
        3:'-megci',
      },
      3: {
        1:'-megnegu',
        2:'-megkek',
        3:'-megki',
      },
      4: {
        1:'-megni',
        2:'-megtek',
        3:'-megteng',
      },
    },
    3: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'-mte4en',
        2:'-mcetek',
        3:'-mceci',
      },
      3: {
        1:'-mte4u',
        2:'-mtekek',
        3:'-mteki',
      },
      4: {
        1:'-mteni',
        2:'-mcetek',
        3:'-mceteng',
      },
    }
  },
  2: {
    1: {
      1: {
        1:'+(t)venga',
        2:'+(t)vekuk',
        3:'+(t)vekut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'+(t)vegu',
        2:'+(t)vekek',
        3:'+(t)veki',
      },
      4: {
        1:'+(t)veni',
        2:'+(t)vetek',
        3:'+(t)veteng',
      },
    },
    2: {
      1: {
        1:'+(t)vetegnga',
        2:'+(t)vetegkuk',
        3:'+(t)vetegkut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'+(t)vetegni',
        2:'+(t)vetegtek',
        3:'+(t)vetegteng',
      },
      4: {
        1:'+(t)vetgu',
        2:'+(t)vetegkek',
        3:'+(t)vetegki',
      },
    },
    3: {
      1: {
        1:'+(t)vecia',
        2:'+(t)vecikuk',
        3:'+(t)vecikut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'+(t)veciu',
        2:'+(t)vecikek',
        3:'+(t)veciki',
      },
      4: {
        1:'+(t)vece7i',
        2:'+(t)vecetek',
        3:'+(t)veceteng',
      }
    }
  },
  3: {
    1: {
      1: {
        1:':anga',
        2:':akuk',
        3:':akut',
      },
      2: {
        1:':aten',
        2:':atek',
        3:':aci',
      },
      3: {
        1:':aku',
        2:':akek',
        3:':aki',
      },
      4: {
        1:':ani',
        2:':atek',
        3:':ateng',
      },
    },
    2: {
      1: {
        1:':agnga',
        2:':agkuk',
        3:':agkut',
      },
      2: {
        1:':agten',
        2:':agtek',
        3:':agci',
      },
      3: {
        1:':agku',
        2:':agkek',
        3:':agki',
      },
      4: {
        1:':agni',
        2:':agtek',
        3:':agteng',
      },
    },
    3: {
      1: {
        1:':atnga',
        2:':atkuk',
        3:':atkut',
      },
      2: {
        1:':atgen',
        2:':acetek',
        3:':aceci',
      },
      3: {
        1:':atgu',
        2:':atkek',
        3:':atki',
      },
      4: {
        1:':atni',
        2:':acetek',
        3:':aceteng',
      },
    }
  },
  4: {
    1: {
      1: {
        1:'+minia',
        2:'+minikuk',
        3:'+minikut',
      },
      2: {
        1:'+miniten',
        2:'+minitek',
        3:'+minici',
      },
      3: {
        1:'+miniu',
        2:'+minikek',
        3:'+miniki',
      },
      4: {
        1:'',
        2:'',
        3:'',
      },
    },
    2: {
      1: {
        1:'+minegnenga',
        2:'+minegnekuk',
        3:'+minegnekut',
      },
      2: {
        1:'+minegnegen',
        2:'+minegnetek',
        3:'+minegneci',
      },
      3: {
        1:'+minegnegu',
        2:'+minegnekek',
        3:'+minegneki',
      },
      4: {
        1:'',
        2:'',
        3:'',
      },
    },
    3: {
      1: {
        1:'+minegtenga',
        2:'+minegtekuk',
        3:'+minegtekut',
      },
      2: {
        1:'+minegte4en',
        2:'+minegcetek',
        3:'+minegneci',
      },
      3: {
        1:'+minegte4u',
        2:'+minegtekek',
        3:'+minegteki',
      },
      4: {
        1:'',
        2:'',
        3:'',
      }
    }
  }
};

export const connective_conditional_intransitive_endings = {
  1: {
    1: '+ma',
    2: '-megnuk',
    3: '-mta',
  },
  2: {
    1: '+(t)vet',
    2: '+(t)vtek',
    3: '+(t)vci',
  },
  3: {
    1: ':an',
    2: ':agnek',
    3: ':ata',
  },
  4: {
    1: '+mi',
    2: '+mek',
    3: '+meng',
  }
};

export const connective_conditional_transitive_endings = {
  1: {
    1: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'-mken',
        2:'-mtek',
        3:'-mci',
      },
      3: {
        1:'-mku',
        2:'-mkek',
        3:'-mki',
      },
      4: {
        1:'-mni',
        2:'-mtek',
        3:'-mteng',
      },
    },
    2: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'-megten',
        2:'-megtek',
        3:'-megci',
      },
      3: {
        1:'-megnegu',
        2:'-megkek',
        3:'-megki',
      },
      4: {
        1:'-megni',
        2:'-megtek',
        3:'-megteng',
      },
    },
    3: {
      1: {
        1:'',
        2:'',
        3:'',
      },
      2: {
        1:'-mte4en',
        2:'-mcetek',
        3:'-mceci',
      },
      3: {
        1:'-mte4u',
        2:'-mtekek',
        3:'-mteki',
      },
      4: {
        1:'-mteni',
        2:'-mcetek',
        3:'-mceteng',
      },
    }
  },
  2: {
    1: {
      1: {
        1:'+(t)vnga',
        2:'+(t)vkuk',
        3:'+(t)vkut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'+(t)vgu',
        2:'+(t)vkek',
        3:'+(t)vki',
      },
      4: {
        1:'+(t)vni',
        2:'+(t)vtek',
        3:'+(t)vteng',
      },
    },
    2: {
      1: {
        1:'+(t)vtegnga',
        2:'+(t)vtegkuk',
        3:'+(t)vtegkut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'+(t)vtegni',
        2:'+(t)vtegtek',
        3:'+(t)vtegteng',
      },
      4: {
        1:'+(t)vtegu',
        2:'+(t)vtegkek',
        3:'+(t)vtegki',
      },
    },
    3: {
      1: {
        1:'+(t)vcia',
        2:'+(t)vcikuk',
        3:'+(t)vcikut',
      },
      2: {
        1:'',
        2:'',
        3:'',
      },
      3: {
        1:'+(t)vciu',
        2:'+(t)vcikek',
        3:'+(t)vciki',
      },
      4: {
        1:'+(t)vce7i',
        2:'+(t)vcetek',
        3:'+(t)vceteng',
      }
    }
  },
  3: {
    1: {
      1: {
        1:':anga',
        2:':akuk',
        3:':akut',
      },
      2: {
        1:':aten',
        2:':atek',
        3:':aci',
      },
      3: {
        1:':aku',
        2:':akek',
        3:':aki',
      },
      4: {
        1:':ani',
        2:':atek',
        3:':ateng',
      },
    },
    2: {
      1: {
        1:':agnga',
        2:':agkuk',
        3:':agkut',
      },
      2: {
        1:':agten',
        2:':agtek',
        3:':agci',
      },
      3: {
        1:':agku',
        2:':agkek',
        3:':agki',
      },
      4: {
        1:':agni',
        2:':agtek',
        3:':agteng',
      },
    },
    3: {
      1: {
        1:':atnga',
        2:':atkuk',
        3:':atkut',
      },
      2: {
        1:':atgen',
        2:':acetek',
        3:':aceci',
      },
      3: {
        1:':atgu',
        2:':atkek',
        3:':atki',
      },
      4: {
        1:':atni',
        2:':acetek',
        3:':aceteng',
      },
    }
  },
  4: {
    1: {
      1: {
        1:'+nia',
        2:'+nikuk',
        3:'+nikut',
      },
      2: {
        1:'+niten',
        2:'+nitek',
        3:'+nici',
      },
      3: {
        1:'+niu',
        2:'+nikek',
        3:'+niki',
      },
      4: {
        1:'',
        2:'',
        3:'',
      },
    },
    2: {
      1: {
        1:'+negnenga',
        2:'+negnekuk',
        3:'+negnekut',
      },
      2: {
        1:'+negnegen',
        2:'+negnetek',
        3:'+negneci',
      },
      3: {
        1:'+negnegu',
        2:'+negnekek',
        3:'+negneki',
      },
      4: {
        1:'',
        2:'',
        3:'',
      },
    },
    3: {
      1: {
        1:'+negtenga',
        2:'+negtekuk',
        3:'+negtekut',
      },
      2: {
        1:'+negte4en',
        2:'+negcetek',
        3:'+negneci',
      },
      3: {
        1:'+negte4u',
        2:'+negtekek',
        3:'+negteki',
      },
      4: {
        1:'',
        2:'',
        3:'',
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/constants/constants_verbs.js